import { useInjectedService } from '../../services/ioc/service-dependency';
import './privacy-policy.css';

const PrivacyPolicy = () => {
    const { localizationService } = useInjectedService();

    return <div className="bbraun-hero bbraun-privacy-policy">
        <h2 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel1") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText1") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText2") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText3") }} />

        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel2") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel3") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText4") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel4") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText5") }} />

        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel5") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText6") }} />

        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel6") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText7") }} />

        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel7") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText8") }} />

        <h3 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel8") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel9") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText9") }} />

        <ul style={{ listStyle: "numeric" }}>
            <li style={{ marginBottom: "10px" }} dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyUnorderedList1Element1") }} />
            <li style={{ marginBottom: "10px" }} dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyUnorderedList1Element2") }} />
            <li style={{ marginBottom: "10px" }}>
                <div dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyUnorderedList1Element3") }} />
                <div style={{ margin: "10px 0" }} dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyUnorderedList1Element3Hint") }} />
            </li>
            <li style={{ marginBottom: "10px" }} dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyUnorderedList1Element4") }} />
        </ul>

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel10") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText10") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel11") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText11") }} />

        <u dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText12") }} />
        <p>
            <ul>
                <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText13") }} />
            </ul>
        </p>

        <u dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText14") }} />
        <p>
            <ul>
                <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText15") }} />
                <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText16") }} />
                <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText17") }} />
            </ul>
        </p>

        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText18") }} />

        <u dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText19") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText20") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel12") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText21") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel13") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText22") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel14") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText23") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel15") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText24") }} />
        <ul>
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText25") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText26") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText27") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText28") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText29") }} />
        </ul>
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText30") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel16") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText31") }} />
        <ul>
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText32") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText33") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText34") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText35") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText36") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText37") }} />
            <li dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText38") }} />
        </ul>

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel17") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText39") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel18") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText40") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel19") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText41") }} />

        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText42") }} />

        <h4 dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyLabel20") }} />
        <p dangerouslySetInnerHTML={{ __html: localizationService.getLocalizedText("PrivacyPolicyText43") }} />
    </div >;
}

export default PrivacyPolicy;
